import {
  Button,
  Grid,
  Paper,
  styled,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import React, { useState } from "react";
import { useRemoveRiwayatPekerjaan } from "../../../../api/effects/mutations/RiwayatPekerjaan/removeRiwayatPekerjaan";
import useFetchAllRiwayatPekerjaan from "../../../../api/effects/queries/RiwayatPekerjaan/useFetchAllRiwayatPekerjaan";
import { RemoveModal } from "../../../../components/RemoveModal";
import { convertDate } from "../../../../utils/dateConvert";
import separateNumber from "../../../../utils/formatPrice";
import RiwayatPekerjaanModal from "./RiwayatPekerjaanModal";

const SquareGrid = styled(Grid)(({ theme }) => ({
  backgroundColor: "#FFF",
  height: "auto",
  width: "90%",
  boxShadow: "1px 1px 10px #888888",
  borderRadius: "10px",
  padding: "1%",
  [theme.breakpoints.down("sm")]: {
    padding: "10px",
  },
  margin: "1%",
}));

export default function RiwayatPekerjaanTable() {
  const [editId, setEditId] = useState<number | null>(null);
  const [deletingId, setDeletingId] = useState<number | null>(null);
  const [removeModalText, setRemoveModalText] = useState("");

  const { data: riwayatPekerjaanData } = useFetchAllRiwayatPekerjaan();

  const handleOpenRemoveModal = (text: string, id: number) => {
    setDeletingId(id);
    setRemoveModalText(`Remove ${text}?`);
  };

  const handleCloseRemoveModal = () => {
    setDeletingId(null);
  };

  const handleOpenEditModal = (id: number) => {
    setEditId(id);
  };

  const handleCloseEditModal = () => {
    setEditId(null);
  };

  const { mutateAsync: RemoveRiwayatPekerjaan } = useRemoveRiwayatPekerjaan({
    onSuccess() {
      console.log("Success");
    },
    onError() {
      console.log("Error");
    },
  });

  const handleRemove = () => {
    if (deletingId !== null) {
      RemoveRiwayatPekerjaan(deletingId);
      handleCloseRemoveModal();
    }
  };

  return (
    <Grid container justifyContent="center">
      <RiwayatPekerjaanModal
        open={!!editId}
        handleClose={handleCloseEditModal}
        ID={editId || undefined}
      />
      <RemoveModal
        open={!!deletingId}
        handleClose={handleCloseRemoveModal}
        handleRemove={handleRemove}
        text={removeModalText}
      />
      <SquareGrid container>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell align="center">Action</TableCell>
                <TableCell>Nama Perusahaan</TableCell>
                <TableCell>Jabatan Akhir</TableCell>
                <TableCell>Tahun Masuk</TableCell>
                <TableCell>Tahun Keluar</TableCell>
                <TableCell>Gaji Terakhir</TableCell>
                <TableCell>Alasan Berhenti</TableCell>
                <TableCell align="center">Hapus</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {riwayatPekerjaanData?.map((row) => (
                <TableRow
                  key={row.RIWAYAT_PEKERJAAN_ID}
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell align="center">
                    <Button
                      onClick={() =>
                        handleOpenEditModal(row.RIWAYAT_PEKERJAAN_ID)
                      }
                      disabled={!!deletingId || !!editId}
                    >
                      Ubah
                    </Button>
                  </TableCell>
                  <TableCell>{row.NAMA_PERUSAHAAN}</TableCell>
                  <TableCell>{row.JABATAN_AKHIR}</TableCell>
                  <TableCell>{convertDate(row.TAHUN_MASUK)}</TableCell>
                  <TableCell>
                    {row.TAHUN_KELUAR === null
                      ? "-"
                      : convertDate(row.TAHUN_KELUAR)}
                  </TableCell>
                  <TableCell>
                    {row.GAJI_TERAKHIR === null
                      ? "-"
                      : `Rp. ${separateNumber(row.GAJI_TERAKHIR)}`}
                  </TableCell>
                  <TableCell>{row.ALASAN_BERHENTI}</TableCell>
                  <TableCell align="center">
                    <Button
                      color="error"
                      onClick={() =>
                        handleOpenRemoveModal(
                          `${row.NAMA_PERUSAHAAN} ${row.JABATAN_AKHIR}`,
                          row.RIWAYAT_PEKERJAAN_ID
                        )
                      }
                      disabled={!!deletingId || !!editId}
                    >
                      Hapus
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </SquareGrid>
    </Grid>
  );
}